var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 0.833496C6.25126 0.833496 4.8335 2.25126 4.8335 4.00016C4.8335 5.74906 6.25126 7.16683 8.00016 7.16683C9.74906 7.16683 11.1668 5.74906 11.1668 4.00016C11.1668 2.25126 9.74906 0.833496 8.00016 0.833496ZM5.8335 4.00016C5.8335 2.80355 6.80355 1.8335 8.00016 1.8335C9.19678 1.8335 10.1668 2.80355 10.1668 4.00016C10.1668 5.19678 9.19678 6.16683 8.00016 6.16683C6.80355 6.16683 5.8335 5.19678 5.8335 4.00016Z",
    fill: "#ACB9C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00016 8.16683C4.25126 8.16683 2.8335 9.58459 2.8335 11.3335C2.8335 13.0824 4.25126 14.5002 6.00016 14.5002H10.0002C11.7491 14.5002 13.1668 13.0824 13.1668 11.3335C13.1668 9.58459 11.7491 8.16683 10.0002 8.16683H6.00016ZM3.8335 11.3335C3.8335 10.1369 4.80355 9.16683 6.00016 9.16683H10.0002C11.1968 9.16683 12.1668 10.1369 12.1668 11.3335C12.1668 12.5301 11.1968 13.5002 10.0002 13.5002H6.00016C4.80355 13.5002 3.8335 12.5301 3.8335 11.3335Z",
    fill: "#ACB9C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.cec33568b3c3fbadd82701c3205894e7.svg";
export { ForwardRef as ReactComponent };